@if (files && total > 0) {
  <bic-badge [interactive]="true"
             [tooltip]="title"
             [tooltipContent]="details"
             [tooltipWidth]="tooltipWidth"
             tooltipDirection="bottom">
    {{ label }}
  </bic-badge>
} @else if (files) {
  <bic-badge>0 Dateien</bic-badge>
} @else {
  <span class="text-sm text-gray-500">–</span>
}

<ng-template #details>
  <div class="flex flex-col gap-2.5 w-[272px] pt-1">
    <div class="flex flex-row flex-wrap gap-1.5">
      @for (entry of $safeNavigationMigration(files?.byType) | keyvalue: keepOrder; track entry.key) {
        <span class="rounded-md bg-gray-200 px-2.5 py-0.5 text-xs font-medium text-gray-700">{{ entry.key }} {{ entry.value }}</span>
      }
    </div>
    <div class="h-px w-full bg-white/20"></div>
    <div class="flex flex-col gap-1.5">
      @for (name of files?.preview ?? []; track $index) {
        <div class="flex flex-row items-center gap-2 min-w-0">
          <fa-icon [icon]="faFile" class="shrink-0 text-svg-16 text-gray-300"></fa-icon>
          <span class="truncate min-w-0 text-xs text-white">{{ name }}</span>
        </div>
      }
    </div>
    @if (remaining > 0) {
      <span class="text-xs font-medium text-gray-400">+ {{ remaining }} weitere</span>
    }
  </div>
</ng-template>
